import { render, staticRenderFns } from "./QuoteActionDelete.vue?vue&type=template&id=1b226a06&"
import script from "./QuoteActionDelete.vue?vue&type=script&lang=ts&"
export * from "./QuoteActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports